// extracted by mini-css-extract-plugin
export default {"content":"style_content__LJiDi","itemName":"style_itemName__+eyul"};